import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { Modal, Text, LoadingImage } from '@tradingblock/components';

interface NoPassAuthModalProps {
  show: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const NoPassAuthModal: React.FC<NoPassAuthModalProps> = ({ show, onClose, onContinue, children }) => {
  return (
    <Modal setShow={() => onClose()} show={show} backdrop="static" className="nopass-auth-modal">
      <BootstrapModal.Header
        closeButton={true}
        style={{ borderBottom: '1px solid #19bab4', backgroundColor: '#001236', color: '#FFF' }}
        className="nopass-auth-modal-header"
      >
        <BootstrapModal.Title style={{ textAlign: 'center' }}>Authentication Request</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body style={{ backgroundColor: '#19bab4' }}>{children}</BootstrapModal.Body>
      <BootstrapModal.Footer style={{ borderTop: '1px solid #19bab4', backgroundColor: '#001236' }}>
        <button
          type="button"
          onClick={() => onClose()}
          style={{
            backgroundColor: '#02FFF6',
            color: '#001236',
            border: 'none',
            borderRadius: '4px',
            padding: '10px 20px',
            cursor: 'pointer',
            fontWeight: 'bold',
          }}
        >
          Close
        </button>
      </BootstrapModal.Footer>
    </Modal>
  );
};
